import { useEffect } from 'react';
import { MdAdd } from 'react-icons/md';

import { Translate } from '@spazious/dollhouse-i18n';
import { FShallowNodeTypesEnum } from '@spazious/dollhouse-shallow-graph';
import { useGraph, useStore } from '@spazious/dollhouse-store';
import { styled } from '@spazious/dollhouse-theme';
import { ControlsModeEnum } from '@spazious/dollhouse-types';
import { Button, Stack, StackProps, Typography } from '@spazious/dollhouse-uikit';
import { useEventCallback } from '@spazious/react-hooks';

import { AnnotationStatusEnum, useAnnotation } from '../../hooks/index.js';

export const AnnotationHint = styled.div`
  display: inline-flex;
  white-space: nowrap;
  padding: calc(var(--spacing-gap) / 2);
  background-color: var(--spz-sys-color-surface-container-highest);
  border: 1px solid var(--spz-sys-color-surface-container);
  border-radius: calc(var(--shape-rounded-radius) / 2);
  z-index: 10;
`;

export const AnnotationToolControls: React.FC<StackProps> = (props) => {
  const { setStatus, annotations } = useAnnotation();
  const set = useStore(({ set }) => set);
  const { graph } = useGraph();

  const handleAddAnnotation = useEventCallback(() => {
    set({
      controls: ControlsModeEnum.Zenithal,
    });
    setStatus(AnnotationStatusEnum.Add);
    graph.layers.enable(FShallowNodeTypesEnum.Annotation);
  });
  useEffect(() => {
    graph.layers.enable(FShallowNodeTypesEnum.Annotation);
    return () => {
      graph.layers.disable(FShallowNodeTypesEnum.Annotation);
    };
  }, [graph.layers]);

  return (
    <Stack {...props} justifyContent="center">
      {annotations.status === AnnotationStatusEnum.Ready && (
        <Button size="extraSmall" style={{ cursor: 'pointer' }} onClick={handleAddAnnotation}>
          <MdAdd />
        </Button>
      )}
      {annotations.status === AnnotationStatusEnum.Add && (
        <AnnotationHint>
          <Typography size="small" variant="label">
            <Translate>Click on the scene</Translate>
          </Typography>
        </AnnotationHint>
      )}
    </Stack>
  );
};
